import { createFileRoute } from '@tanstack/react-router'

import { WarehouseStatsPage } from '@/components/warehouse/warehouse-stats-page'

export const Route = createFileRoute('/_app/_authed/_sidebar/warehouse-stats')({
    component: WarehouseStatsPage,
})
